import { render, staticRenderFns } from "./ArticleZoom.vue?vue&type=template&id=afb0bbde&scoped=true&"
import script from "./ArticleZoom.vue?vue&type=script&lang=js&"
export * from "./ArticleZoom.vue?vue&type=script&lang=js&"
import style0 from "./ArticleZoom.vue?vue&type=style&index=0&id=afb0bbde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb0bbde",
  null
  
)

export default component.exports